import React from 'react'
import { Image } from 'Components/view-image'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
const car_error_bg = require('static/car-error-bg.svg')

interface IProps {
  coverUrl?: string
  name?: string
  fansCount?: number
  id?: string
  onClick?(): void
}

const HotCommunityItem: React.FC<IProps> = ({
  coverUrl,
  name,
  id,
  fansCount = 0,
  onClick,
}) => {
  return (
    <React.Fragment>
      <a
        className="tw-text-12 md:tw-text-14"
        role="button"
        target={'_blank'}
        href={`/community/${id}`}
        onClick={onClick}
      >
        <div
          className="tw-h-95 tw-flex tw-py-8"
          onClick={(e) => {
            e.stopPropagation()
            if (onClick) {
              onClick()
            }
          }}
        >
          <div className="tw-h-full tw-w-4/12 tw-flex-none tw-flex tw-items-center ">
            <Image
              src={coverUrl || ''}
              width={100}
              height={66}
              autoPixelRatio={true}
              cusDefaultImg={car_error_bg}
              errorImg={car_error_bg}
              className="tw-rounded-2"
            />
          </div>

          <div className="tw-pl-16 tw-overflow-hidden">
            <p className="tw-text-14 xl:tw-text-16 tw-font-medium line-1 tw-leading-22">
              {name}车友圈
            </p>
            <p className="tw-text-12 tw-text-color-gray-800 tw-mt-6 tw-leading-18">
              {formatNumber(fansCount)}车友活跃中
            </p>
            <p className="tw-mt-6 tw-leading-20 tw-text-12 md:tw-text-14">
              进入车友圈
              <i className="DCD_Icon icon_PC-triangle tw-text-12 md:tw-text-14 tw-ml-4" />
            </p>
          </div>
        </div>
      </a>
    </React.Fragment>
  )
}

export default HotCommunityItem
